import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import 'primeicons/primeicons.css';
import './ConsultancyofficerMenu.css';
import { MenuItem } from 'primereact/menuitem';

const ConsultancyofficerMenu = () => {
const items: MenuItem[] = [
    {
      label: 'Login',
      icon: 'pi pi-sign-in',
      url: '/medi/cologin',
    },
    {
      label: 'Activities',
      icon: 'pi pi-list',
      url: '/medi/coactivities',
    },
  ]; 
   return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="menu-container" style={{margin:'0px 10px'}}>
          <PanelMenu model={items} style={{backgroundColor:'#fff'}} />
        </div>
      </div>
    </aside>
  );
};

export default ConsultancyofficerMenu;

